// ============================================
// FILE: constants/formOptions.js
// ============================================

export const configurationList = ['1BHK', '2BHK', '3BHK', '4BHK', '5+BHK'];
export const propertyTypeList = ['Villa', 'Independent House', 'Apartment'];
export const possessionTypeList = ['0 - 3 months', '3 - 6 months', '6 - 9 months', '9 - 12 months'];
export const cityList = ['Bangalore', 'Kolkata'];
export const requirementTypeList = ['End-to-end', 'Partial'];
export const serviceTypeList = ['Interiors', 'Renovation'];
export const salesRepList = [
  { label: 'Ashwin', value: 'Ashwin', uid: 'CPQvno0xkHM7ReOjppP3Wc5CWxE3', branch: 'BLR-KN' },
  { label: 'Reshma', value: 'Reshma', uid: 'PocepGixlLZ9vJCxOcMEzKpxyLF2', branch: 'BLR-KN' },
  // { label: 'Lavanya', value: 'Lavanya', uid: 'bcT4yEBC7cMB90jKZGK7re1ktp53', branch: 'BLR-KN' },
  { label: 'Preethi N', value: 'Preethi N', uid: 'vy1T91udztPE74dsQqJfv2MYY0X2', branch: 'BLR-KN' },
  { label: 'Pradeep', value: 'Pradeep', uid: 'A1FeeayZe3YIKGMPBMPjB7hOHzm2', branch: 'BLR-KN' },
  { label: 'Ranjitha Rana', value: 'Ranjitha Rana', uid: 'imQbcngPMHNFJhuaoXuTOpWqZkK2', branch: 'BLR-KN' },
  { label: 'Rhea', value: 'Rhea', uid: 'ukSZqrqM1aNJvnuidFmHRNC6Cst1', branch: 'BLR-KN' },
  { label: 'H Henthoi Chanu', value: 'H Henthoi Chanu', uid: 'sUwnkivh40dZ434IEQOJC2UWuUG2', branch: 'BLR-KN' },
  { label: 'Summi', value: 'Summi', uid: 'RubEsZZrMBcvnvdT1hyu0eErZLO2', branch: 'BLR-HRBR' },
  { label: 'Ananya', value: 'Ananya', uid: 'xS8lE99DW7PP3oEyXgI074EgVfI3', branch: 'BLR-HRBR' },
  { label: 'Veeral', value: 'Veeral', uid: 'nPOwESh2VET0PhfLUNCZpLDQkbY2', branch: 'BLR-HRBR' },
  { label: 'Bhargavi', value: 'Bhargavi', uid: 'R3N5KR1TIESA1PI7izJmZ20EAu82', branch: 'BLR-HRBR' },
  { label: 'Azhar', value: 'Azhar', uid: '9iXL6c0tXBQelRAjrce5iQpT28u1', branch: 'KKT-NT' },
  { label: 'Kabita Bose', value: 'Kabita Bose', uid: 'n15mR4VSIyOnYkflftn2ealugKa2', branch: 'KKT-NT' },
  { label: 'Shubham', value: 'Shubham', uid: '26ezWcULohR7nLV5PikPYgb3dNh1', branch: 'KKT-NT' },
   { label: 'Arjun Basu', value: 'Arjun Basu', uid: 'r3QGk9Lb1fX00JHiX5eiJJB7ELv2', branch: 'KKT-NT' }
  // { label: 'Hyder', value: 'Hyder', uid: 'zKJvJmP036bIUtbJl4XUhgQjQsj1', branch: 'KKT-NT' }
];

export const preSalesRepList = [
  { label: 'Sabeel Pasha', value: 'Sabeel Pasha', uid: 'iaJnP9ln0cO8wZDyF8LcruUZPmw2', branch: 'BLR-HRBR' },
  { label: 'Sangeetha A', value: 'Sangeetha A', uid: 'RVcXVo2dKuVfTjvjeZd13kJPeCf2', branch: 'BLR-HRBR' },
  { label: 'Uma Maheswari', value: 'Uma Maheswari', uid: 'Jl4aCtwv0BNqppOz2HpI0FVtk393', branch: 'BLR-HRBR' },
   { label: 'Meegha S', value: 'Meegha S', uid: 'saER0fssk0WtbGc7b1vmaWbACH13', branch: 'BLR-HRBR' },
  { label: 'Danish', value: 'Danish', uid: 'Tf6XJEIDTLNIsORh4QLQLEWB8B33', branch: 'BLR-HRBR' },
  // { label: 'Oswald', value: 'Oswald', uid: 'vVTn5BgeSPZyyeeeEGK1YjakZtN2', branch: 'BLR-HRBR' },
  { label: 'Tawsif Alam', value: 'Tawsif Alam', uid: 'US7k3tsz41du5u4v05BSPGzlz0N2', branch: 'KKT-NT' },
  { label: 'Saaliha Jilani', value: 'Saaliha Jilani', uid: 'val7ed1IgPWSXB2AQ8w72gFavPn1', branch: 'KKT-NT' },
  { label: 'Anushree M', value: 'Anushree M', uid: 'WwBxPRotcCYUl3Q5OLQuLF1zUR32', branch: 'BLR-HRBR' },
  { label: 'Monisha P', value: 'Monisha P', uid: '5tn0hBF1BIdDkbWx9muS32Hvgzj1', branch: 'BLR-HRBR' },
  { label: 'NA', value: 'NA', uid: '', branch: '' },
];

export const sourceList = [
  'Google',
  'Raw Data',
  'Facebook',
  'Client Referral',
  'Referral',
  'Direct',
  'Employee Referral',
  'Community Referral',
  'Genie Homes',
  'Instagram',
  'SHL',
  'Priyanshi CP',
  'Tanya CP',
  'Aruna CP',
  'Sri Durga Innovation CP',
  'Padmanabha CP',
  'Satya Prasad CP',
  'AIS NEXT CEILING CP',
  'Krafted Homes CP'
];
export const channelList = ['Call', 'WhatsApp', 'Walk-In', 'Form', 'Channel Partner', 'SBD', 'Profiled Data', 'Raw Data', 'CP Referred', 'Other'];
export const mediumList = ['Paid', 'Organic'];

